import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { useTranslation } from '@root/shared/localization'
import { ConfirmDialog } from '@root/shared/ui-kit'

import { reatomDeleteWallet } from '../../atoms'

import type { WalletModel } from '@root/entities/wallet'
import type { DialogControlProps } from '@root/shared/ui-kit'

type DeleteWalletDialogProps = {
  wallet: WalletModel
} & DialogControlProps

export const DeleteWalletDialog: React.FC<DeleteWalletDialogProps> = ({
  wallet,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  const deleteModel = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomDeleteWallet({ wallet }),
    [wallet],
  )
  const [deleteWalletState] = useAtom(deleteModel)
  const deleteWallet = useAction(deleteModel.execute)

  return (
    <ConfirmDialog
      describedBy="delete-wallet-dialog"
      intent="error"
      onConfirm={deleteWallet}
      open={open}
      icon="danger"
      header={t('wallet.deleting_a_wallet')}
      title={t('wallet.delete_confirmation.subtitle')}
      description={t('wallet.delete_confirmation.description')}
      onOpenChange={onOpenChange}
      busy={deleteWalletState.loading}
      onCancel={() => onOpenChange?.(false)}
    />
  )
}
